import { DeviceStatus, DeviceStatusCause } from 'types/device.enum';
import SamplePoint from 'types/models/samplePoint';

export type DeviceId = number;

export enum BackhaulType {
  CELL = 1,
  GLOBAL_STAR = 2,
  INMARSAT = 4,
  API_CONNECTED = 5
}

export enum BackhaulDesc {
  CELL_CAT1 = 'Cell Cat1',
  GLOBAL_STAR_SBD = 'GlobalStar SBD',
  INMARSAT_IDP = 'Inmarsat IDP'
}

export const BACKHAUL_DESC_TO_LABEL: Record<BackhaulDesc, string> = {
  [BackhaulDesc.CELL_CAT1]: 'Cellular',
  [BackhaulDesc.GLOBAL_STAR_SBD]: 'Simplex Satellite',
  [BackhaulDesc.INMARSAT_IDP]: 'Duplex Satellite'
};

export enum DeviceModel {
  LITE = 'LITE',
  MK5 = 'MK5',
  MK6 = 'MK6',
  XTEND_MKI = 'Xtend MKI',
  XTEND_TROUGH = 'Xtend Trough',
  TROUGH_DIRECT = 'Trough Direct'
}

export default interface Device {
  id: DeviceId;
  enterpriseId: number | null;
  siteId: number | null;
  name: string;
  dataSourceId: number;
  backhaulDeviceId: number;
  backhaulType: BackhaulType;
  backhaulDesc: string;
  serialNumber: string;
  comments: string;
  make: string;
  model: DeviceModel;
  hwVersion: string;
  fwVersion: string;
  libVersion: string;
  battSamplePointId?: number;
  battSamplePoint?: SamplePoint;
  batteryLevel: number;
  isBatteryLow: boolean;
  /**
   * Low-battery threshold. Resolved by the API from the sample point's battery-low trigger when configured, or from
   * device-model/backhaul defaults. This ensures that consumers will always receive a value even when no trigger is
   * configured on the sample point.
   */
  lowBatteryLevel: number;
  positionLat?: number;
  positionLong?: number;
  gpsSamplePoint?: SamplePoint;
  loraGpsSamplePoints: SamplePoint[];
  loraBatterySamplePoints: SamplePoint[];
  lastBootCause: string;
  lastBootDate: number;
  lastDataDate: number;
  lastConfigDate: number;
  status: DeviceStatus; // From FRED
  lastStatusDate: number; // From FRED
  statusCause: DeviceStatusCause; // From FRED

  createdAt: number;
  updatedAt: number;
}
